import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-location-bpams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-location-bpams.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { CreateApplicationLocationBpamsConstants } from "./create-application-location-bpams.constants";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { AppControllerService } from "../../../../app-controller.service";
import { AlertType } from "../../../../shared/models/alert";
import { ApiProxyConstants } from "../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../app.config";
import { AppRoutingConstants } from "../../../../app-routing.constants";
import { UrlConstants } from "../../../../shared/constants/url.constants";
import Query from "@arcgis/core/rest/support/Query";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { MapService } from "../../../../map/shared/map.service";
import { MapServiceConstants } from "../../../../map/map-service.constants";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { ApiModuleConstants } from "../../../../shared/constants/api-constants/api-module.constants";
import { BehaviorSubject } from "rxjs";
import { PropertyBuildingHeadingEnumHeadingLookup } from "./property-building-heading.model";
import { AddBuildingComponent } from "./add-building/add-building.component";
import { EditBuildingComponent } from "./edit-building/edit-building.component";
import { PopUpComponent } from "../../../../shared/components/pop-up/pop-up.component";
import { WktConverterUtils } from "../../../../shared/utils/wkt-converter-utils";
import { CreateApplicationUtils } from "../../../shared/utils/create-application-utils";
import { ViewApplicationLocationBpamsConstants } from "../../../../view-application/modules/bp/view-application-location-bpams/view-application-location-bpams.constants";
import { MapTools } from "src/app/map/shared/map.tools";
export let CreateApplicationLocationBpamsComponent = class CreateApplicationLocationBpamsComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    mapService;
    requestStatusService;
    mapTools;
    changeDetectorRefs;
    modalService;
    active;
    propertiesForm;
    descriptionLabel1 = CreateApplicationLocationBpamsConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = CreateApplicationLocationBpamsConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = CreateApplicationLocationBpamsConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = CreateApplicationLocationBpamsConstants.DESCRIPTION_LABEL_4;
    validationMessages = CreateApplicationLocationBpamsConstants.VALIDATION_MESSAGES;
    propertyApplicationDetailsLabel = CreateApplicationLocationBpamsConstants.PROPERTY_APPLICATION_DETAILS_LABEL;
    erfNoControl = CreateApplicationLocationBpamsConstants.ERF_NO_CONTROL;
    subdivisionControl = CreateApplicationLocationBpamsConstants.SUBDIVISION_CONTROL;
    allotmentControl = CreateApplicationLocationBpamsConstants.ALLOTMENT_CONTROL;
    farmNoControl = CreateApplicationLocationBpamsConstants.FARM_NO_CONTROL;
    sgCodeControl = CreateApplicationLocationBpamsConstants.SG_CODE_CONTROL;
    addressControl = CreateApplicationLocationBpamsConstants.ADDRESS_CONTROL;
    erfSizeControl = CreateApplicationLocationBpamsConstants.ERF_SIZE_CONTROL;
    totalValueControl = CreateApplicationLocationBpamsConstants.TOTAL_VALUE_CONTROL;
    titleDeedControl = CreateApplicationLocationBpamsConstants.TITLE_DEED_CONTROL;
    zoneControl = CreateApplicationLocationBpamsConstants.ZONE_CONTROL;
    ownerControl = CreateApplicationLocationBpamsConstants.OWNER_CONTROL;
    erfNoTextPlaceHolder = CreateApplicationLocationBpamsConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = CreateApplicationLocationBpamsConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = CreateApplicationLocationBpamsConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = CreateApplicationLocationBpamsConstants.FARM_NO_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = CreateApplicationLocationBpamsConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = CreateApplicationLocationBpamsConstants.ADDRESS_TEXT_PLACEHOLDER;
    erfSizeTextPlaceHolder = CreateApplicationLocationBpamsConstants.ERF_SIZE_TEXT_PLACEHOLDER;
    totalValueTextPlaceHolder = CreateApplicationLocationBpamsConstants.TOTAL_VALUE_TEXT_PLACEHOLDER;
    titleDeedTextPlaceHolder = CreateApplicationLocationBpamsConstants.TITLE_DEED_TEXT_PLACEHOLDER;
    zoneLabel = CreateApplicationLocationBpamsConstants.ZONE_LABEL;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    addZoneLabel = CreateApplicationLocationBpamsConstants.ADD_ZONE_LABEL;
    copyApplicantToOwnerZoneLabel = CreateApplicationLocationBpamsConstants.COPY_APPLICANT_TO_OWNER_LABEL;
    removePropertyLabel = CreateApplicationLocationBpamsConstants.REMOVE_PROPERTY_LABEL;
    ownerLabel = CreateApplicationLocationBpamsConstants.OWNER_LABEL;
    ownerDisableFilterBy = true;
    ownerDisableAdd = false;
    ownerDisableEditing = false;
    ownerShowGroupsDropdown = true;
    ownerGroups = [];
    ownerListLabel = "Owner";
    zones = [];
    fullApplicationCheckRequired = false;
    showOnlyPropertyAndZoningLayers = false;
    // Application Type
    typeTextPlaceHolder = CreateApplicationLocationBpamsConstants.TYPE_LABEL;
    typeControl = CreateApplicationLocationBpamsConstants.TYPE_CONTROL;
    titleDeedRestrictionsTextPlaceHolder = CreateApplicationLocationBpamsConstants.TITLE_DEED_RESTRICTION_LABEL;
    titleDeedRestrictionsControl = CreateApplicationLocationBpamsConstants.TITLE_DEED_RESTRICTION_CONTROL;
    shortDescriptionTextPlaceHolder = CreateApplicationLocationBpamsConstants.SHORT_DESCRIPTION_LABEL;
    shortDescriptionControl = CreateApplicationLocationBpamsConstants.SHORT_DESCRIPTION_CONTROL;
    estimatedCostTextPlaceHolder = CreateApplicationLocationBpamsConstants.ESTIMATED_COST_LABEL;
    estimatedCostControl = CreateApplicationLocationBpamsConstants.ESTIMATED_COST_CONTROL;
    estimatedByTextPlaceHolder = CreateApplicationLocationBpamsConstants.ESTIMATED_BY_LABEL;
    estimatedByControl = CreateApplicationLocationBpamsConstants.ESTIMATED_BY_CONTROL;
    externalWallsTextPlaceHolder = CreateApplicationLocationBpamsConstants.EXTERNAL_WALLS_LABEL;
    internalWallsTextPlaceHolder = CreateApplicationLocationBpamsConstants.INTERNAL_WALLS_LABEL;
    roofingTextPlaceHolder = CreateApplicationLocationBpamsConstants.ROOFING_LABEL;
    numberOfHousesUnitsTextPlaceHolder = CreateApplicationLocationBpamsConstants.NUMBER_OF_HOUSES_UNITS_LABEL;
    externalWallsControl = CreateApplicationLocationBpamsConstants.EXTERNAL_WALLS_CONTROL;
    internalWallsControl = CreateApplicationLocationBpamsConstants.INTERNAL_WALLS_CONTROL;
    roofingControl = CreateApplicationLocationBpamsConstants.ROOFING_CONTROL;
    numberOfHousesUnitsControl = CreateApplicationLocationBpamsConstants.NUMBER_OF_HOUSES_UNITS_CONTROL;
    buildingDetailsLabel = CreateApplicationLocationBpamsConstants.BUILDING_DETAILS_LABEL;
    mainBuildingLabel = CreateApplicationLocationBpamsConstants.MAIN_BUILDING_LABEL;
    outBuildingLabel = CreateApplicationLocationBpamsConstants.OUT_BUILDING_LABEL;
    buildingTotalLabel = CreateApplicationLocationBpamsConstants.BUILDING_TOTAL_LABEL;
    stoepLabel = CreateApplicationLocationBpamsConstants.STOEP_LABEL;
    miscellaneousLabel = CreateApplicationLocationBpamsConstants.MISCELLANEOUS_LABEL;
    totalExistingPlaceHolder = CreateApplicationLocationBpamsConstants.TOTAL_EXISTING_LABEL;
    totalAddedTextPlaceHolder = CreateApplicationLocationBpamsConstants.TOTAL_ADDED_LABEL;
    totalFloorAreaTextPlaceHolder = CreateApplicationLocationBpamsConstants.TOTAL_FLOOR_AREA_LABEL;
    totalExistingControl = CreateApplicationLocationBpamsConstants.TOTAL_EXISTING_CONTROL;
    totalAddedControl = CreateApplicationLocationBpamsConstants.TOTAL_ADDED_CONTROL;
    totalFloorAreaControl = CreateApplicationLocationBpamsConstants.TOTAL_FLOOR_AREA_CONTROL;
    // patio
    coveredExistingTextPlaceHolder = CreateApplicationLocationBpamsConstants.COVERED_EXISTING_LABEL;
    coveredAddedTextPlaceHolder = CreateApplicationLocationBpamsConstants.COVERED_ADDED_LABEL;
    openExistingTextPlaceHolder = CreateApplicationLocationBpamsConstants.OPEN_EXISTING_LABEL;
    openAddedTextPlaceHolder = CreateApplicationLocationBpamsConstants.OPEN_ADDED_LABEL;
    totalExistingPatioTextPlaceHolder = CreateApplicationLocationBpamsConstants.TOTAL_EXISTING_PATIO_LABEL;
    totalAddedPatioTextPlaceHolder = CreateApplicationLocationBpamsConstants.TOTAL_ADDED_PATIO_LABEL;
    coveredExistingControl = CreateApplicationLocationBpamsConstants.COVERED_EXISTING_CONTROL;
    coveredAddedControl = CreateApplicationLocationBpamsConstants.COVERED_ADDED_CONTROL;
    openExistingControl = CreateApplicationLocationBpamsConstants.OPEN_EXISTING_CONTROL;
    openAddedControl = CreateApplicationLocationBpamsConstants.OPEN_ADDED_CONTROL;
    totalExistingPatioControl = CreateApplicationLocationBpamsConstants.TOTAL_EXISTING_PATIO_CONTROL;
    totalAddedPatioControl = CreateApplicationLocationBpamsConstants.TOTAL_ADDED_PATIO_CONTROL;
    // misc
    poolTextPlaceHolder = CreateApplicationLocationBpamsConstants.POOL_LABEL;
    boundaryWallHeightTextPlaceHolder = CreateApplicationLocationBpamsConstants.BOUNDARY_WALL_HEIGHT_LABEL;
    boundaryWallRunningTextPlaceHolder = CreateApplicationLocationBpamsConstants.BOUNDARY_WALL_RUNNING_LABEL;
    coverageTextPlaceHolder = CreateApplicationLocationBpamsConstants.COVERAGE_LABEL;
    bulkCalculationTextPlaceHolder = CreateApplicationLocationBpamsConstants.BULK_CALCULATION_LABEL;
    calculationsLabel = CreateApplicationLocationBpamsConstants.CALCULATIONS_LABEL;
    poolControl = CreateApplicationLocationBpamsConstants.POOL_CONTROL;
    boundaryWallHeightControl = CreateApplicationLocationBpamsConstants.BOUNDARY_WALL_HEIGHT_CONTROL;
    boundaryWallRunningControl = CreateApplicationLocationBpamsConstants.BOUNDARY_WALL_RUNNING_CONTROL;
    coverageControl = CreateApplicationLocationBpamsConstants.COVERAGE_CONTROL;
    bulkCalculationControl = CreateApplicationLocationBpamsConstants.BULK_CALCULATION_CONTROL;
    deleteLabel = SharedConstants.REMOVE_LABEL;
    editLabel = SharedConstants.EDIT_LABEL;
    addLabel = SharedConstants.ADD_LABEL;
    removeDialogTitle = CreateApplicationLocationBpamsConstants.REMOVE_DIALOG_TEXT;
    removeMainContent = `${SharedConstants.REMOVE_MESSAGE} main building(s)?`;
    removeOutContent = `${SharedConstants.REMOVE_MESSAGE} out building(s)?`;
    selectPromptMessage = SharedConstants.NO_ITEM_SELECTED;
    selectOneDocMessage = SharedConstants.MORE_THAN_ONE_SELECTED;
    zoneOptions = [];
    typeOptions = [];
    estimatedByOptions = [];
    externalWallsOptions = [];
    internalWallsOptions = [];
    roofingOptions = [];
    // @ts-ignore
    mainTableMapper;
    // @ts-ignore
    outTableMapper;
    subdivisionControlRequired = true;
    farmNoControlRequired = true;
    erfNoControlRequired = true;
    mapComponent;
    isMapLoaded = false;
    formValidators = Validators.required;
    hasLoadedApplicationProperties = false;
    missingZoneTuple;
    missingZoneList = new Map();
    modalOptions = {
        size: "lg", centered: true, keyboard: false, backdrop: "static"
    };
    constructor(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, appController, mapService, requestStatusService, mapTools, changeDetectorRefs, modalService) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.mapService = mapService;
        this.requestStatusService = requestStatusService;
        this.mapTools = mapTools;
        this.changeDetectorRefs = changeDetectorRefs;
        this.modalService = modalService;
        this.initializeColumnToObjectMapping();
    }
    get getProperties() {
        return this.propertiesForm.get("properties");
    }
    ngOnInit() {
        this.initForm();
        this.checkAndInitialiseLookups();
        this.getMetadata();
        this.subscribeToProperty();
        this.subscribeToClearGraphics();
        // this.subscribeToSelectedApplication();
        this.changeDetectorRefs.detectChanges();
    }
    ngAfterViewInit() {
        this.mapService.actionPropertyEnabled = true;
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    ngOnDestroy() {
        this.mapService.destroyMap();
        super.ngOnDestroy();
    }
    loadMetadata(stepMeta) {
        this.ownerGroups = stepMeta.ownerGroup;
        this.changeDetectorRefs.markForCheck();
    }
    getZones(propertyIndex) {
        return this.getProperties.controls[propertyIndex].get("zones");
    }
    updatePropertyRequiredFields(newProperty) {
        const erfNoControl = newProperty.get(this.erfNoControl);
        const farmNoControl = newProperty.get(this.farmNoControl);
        const subdivisionControl = newProperty.get(this.subdivisionControl);
        if (erfNoControl.value !== undefined && erfNoControl.value !== null && erfNoControl.value.trim() !== "") {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.clearValidators();
            subdivisionControl.clearValidators();
            farmNoControl.setValue("");
            subdivisionControl.setValue("");
            farmNoControl.disable();
            subdivisionControl.disable();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
            this.subdivisionControlRequired = false;
            this.farmNoControlRequired = false;
            this.erfNoControlRequired = true;
        }
        else if ((farmNoControl.value !== undefined && farmNoControl.value !== null && farmNoControl.value.trim() !== "") || (subdivisionControl.value !== undefined && subdivisionControl.value !== null && subdivisionControl.value.trim() !== "")) {
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.clearValidators();
            erfNoControl.setValue("");
            erfNoControl.disable();
            erfNoControl.markAsUntouched();
            this.subdivisionControlRequired = true;
            this.farmNoControlRequired = true;
            this.erfNoControlRequired = false;
        }
        else {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.enable();
            farmNoControl.enable();
            subdivisionControl.enable();
            erfNoControl.markAsUntouched();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
            this.subdivisionControlRequired = true;
            this.farmNoControlRequired = true;
            this.erfNoControlRequired = true;
        }
        erfNoControl.updateValueAndValidity();
        farmNoControl.updateValueAndValidity();
        subdivisionControl.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    onBtnRemoveZoneClicked(propertyIndex, zoneIndex) {
        const controls = this.getZones(propertyIndex);
        if (controls.controls.length > 1) {
            controls.removeAt(zoneIndex);
        }
    }
    onBtnAddZoneClicked(propertyIndex) {
        const zonesControl = this.getZones(propertyIndex);
        const zoneGroup = new FormGroup({
            zone: new FormControl(null, [Validators.required])
        });
        zonesControl.push(zoneGroup);
    }
    onBtnRemovePropertyClicked(propertyIndex) {
        this.getProperties.removeAt(propertyIndex);
        this.syncMapGeometries();
        this.changeDetectorRefs.detectChanges();
    }
    onBtnRemoveMainClicked($event, propertyIndex) {
        let mainTableSelection = this.getProperties.controls[propertyIndex].get("mainTableSelection").value;
        const mainTableDataSource = this.getProperties.controls[propertyIndex].get("mainTableDataSource").value;
        if (mainTableSelection.length === 0) {
            this.appController.showMessage(this.selectPromptMessage, AlertType.Warning, true);
            return;
        }
        //  const deletedItem = mainTableSelection;
        // let index = 0;
        const itemsAlreadyOnTable = mainTableDataSource.getValue();
        const options = {
            size: "xl", centered: true, keyboard: false, backdrop: "static"
        };
        const title = this.removeDialogTitle;
        const contentMessage = this.removeMainContent;
        const dialogRef = this.modalService.open(PopUpComponent, options);
        dialogRef.componentInstance.title = title;
        dialogRef.componentInstance.contentMessage = contentMessage;
        dialogRef.componentInstance.data = mainTableSelection;
        dialogRef.result.then((deletedIndex) => {
            this.changeDetectorRefs.markForCheck();
            if (deletedIndex) {
                // tslint:disable-next-line:prefer-for-of
                for (let index = 0; index < mainTableSelection.length; index++) {
                    const delIndex = itemsAlreadyOnTable.findIndex(i => i.id === mainTableSelection[index].id);
                    if (delIndex > -1) {
                        itemsAlreadyOnTable.splice(delIndex, 1);
                    }
                }
                for (let index = 0; index < itemsAlreadyOnTable.length; index++) {
                    if (itemsAlreadyOnTable[index].id > 0)
                        continue;
                    itemsAlreadyOnTable[index].id = index !== 0 ? -index : 0;
                }
                const allItems = [...itemsAlreadyOnTable];
                mainTableDataSource.next(allItems);
                mainTableSelection = [];
                this.getProperties.controls[propertyIndex].get("mainTableSelection").setValue(mainTableSelection);
                this.changeDetectorRefs.detectChanges();
                this.syncMainBuildings();
            }
        }).catch((res) => {
        });
    }
    onBtnEditMainClicked($event, propertyIndex) {
        const mainTableSelection = this.getProperties.controls[propertyIndex].get("mainTableSelection").value;
        const mainTableDataSource = this.getProperties.controls[propertyIndex].get("mainTableDataSource").value;
        if (mainTableSelection.length === 0) {
            this.appController.showMessage(this.selectPromptMessage, AlertType.Warning, true);
            return;
        }
        if (mainTableSelection.length > 1) {
            this.appController.showMessage(this.selectOneDocMessage, AlertType.Warning);
            return;
        }
        let index = 0;
        const itemsAlreadyOnTable = mainTableDataSource.getValue();
        for (let i = 0; i < itemsAlreadyOnTable.length; i++) {
            if (itemsAlreadyOnTable[i] === mainTableSelection[0]) {
                index = i;
            }
        }
        const modalRef = this.modalService.open(EditBuildingComponent, this.modalOptions);
        modalRef.componentInstance.modalTitle = "Edit main building";
        modalRef.componentInstance.building = mainTableSelection[0];
        modalRef.componentInstance.editedIndex = index;
        modalRef.result.then((updatedbuilding) => {
            this.changeDetectorRefs.markForCheck();
            if (updatedbuilding) {
                itemsAlreadyOnTable[updatedbuilding[0]] = updatedbuilding[1];
                const allItems = [...itemsAlreadyOnTable];
                mainTableDataSource.next(allItems);
                mainTableSelection[0].selected = false;
                this.getProperties.controls[propertyIndex].get("mainTableSelection").setValue(mainTableSelection);
                this.changeDetectorRefs.detectChanges();
                this.syncMainBuildings();
            }
        }).catch((res) => {
        });
    }
    onBtnAddMainClicked($event, propertyIndex) {
        let mainTableSelection = this.getProperties.controls[propertyIndex].get("mainTableSelection").value;
        const mainTableDataSource = this.getProperties.controls[propertyIndex].get("mainTableDataSource").value;
        const modalRef = this.modalService.open(AddBuildingComponent, this.modalOptions);
        modalRef.componentInstance.modalTitle = "Add main building";
        modalRef.componentInstance.type = "Main Building";
        modalRef.result.then(newBuilding => {
            if (newBuilding) {
                const itemsAlreadyOnTable = mainTableDataSource.getValue();
                const allItems = [...itemsAlreadyOnTable, newBuilding];
                for (let index = 0; index < allItems.length; index++) {
                    if (allItems[index].id > 0)
                        continue;
                    allItems[index].id = index !== 0 ? -index : 0;
                }
                mainTableDataSource.next(allItems);
                mainTableSelection = [];
                this.getProperties.controls[propertyIndex].get("mainTableSelection").setValue(mainTableSelection);
                this.changeDetectorRefs.detectChanges();
                this.syncMainBuildings();
            }
        }).catch((res) => {
        });
    }
    onBtnRemoveOutClicked($event, propertyIndex) {
        let outTableSelection = this.getProperties.controls[propertyIndex].get("outTableSelection").value;
        const outTableDataSource = this.getProperties.controls[propertyIndex].get("outTableDataSource").value;
        if (outTableSelection.length === 0) {
            this.appController.showMessage(this.selectPromptMessage, AlertType.Warning, true);
            return;
        }
        const itemsAlreadyOnTable = outTableDataSource.getValue();
        const options = {
            size: "xl", centered: true, keyboard: false, backdrop: "static"
        };
        const title = this.removeDialogTitle;
        const contentMessage = this.removeOutContent;
        const dialogRef = this.modalService.open(PopUpComponent, options);
        dialogRef.componentInstance.title = title;
        dialogRef.componentInstance.contentMessage = contentMessage;
        dialogRef.componentInstance.data = outTableSelection;
        dialogRef.result.then((deletedIndex) => {
            this.changeDetectorRefs.markForCheck();
            if (deletedIndex) {
                // tslint:disable-next-line:prefer-for-of
                for (let index = 0; index < outTableSelection.length; index++) {
                    const delIndex = itemsAlreadyOnTable.findIndex(i => i.id === outTableSelection[index].id);
                    if (delIndex > -1) {
                        itemsAlreadyOnTable.splice(delIndex, 1);
                    }
                }
                for (let index = 0; index < itemsAlreadyOnTable.length; index++) {
                    if (itemsAlreadyOnTable[index].id > 0)
                        continue;
                    itemsAlreadyOnTable[index].id = index !== 0 ? -index : 0;
                }
                // itemsAlreadyOnTable.splice(deletedIndex, 1);
                const allItems = [...itemsAlreadyOnTable];
                outTableDataSource.next(allItems);
                outTableSelection = [];
                this.getProperties.controls[propertyIndex].get("outTableSelection").setValue(outTableSelection);
                this.changeDetectorRefs.detectChanges();
                this.syncOutBuildings();
            }
        }).catch((res) => {
        });
    }
    onBtnEditOutClicked($event, propertyIndex) {
        const outTableSelection = this.getProperties.controls[propertyIndex].get("outTableSelection").value;
        const outTableDataSource = this.getProperties.controls[propertyIndex].get("outTableDataSource").value;
        if (outTableSelection.length === 0) {
            this.appController.showMessage(this.selectPromptMessage, AlertType.Warning, true);
            return;
        }
        if (outTableSelection.length > 1) {
            this.appController.showMessage(this.selectOneDocMessage, AlertType.Warning);
            return;
        }
        let index = 0;
        const itemsAlreadyOnTable = outTableDataSource.getValue();
        for (let i = 0; i < itemsAlreadyOnTable.length; i++) {
            if (itemsAlreadyOnTable[i] === outTableSelection[0]) {
                index = i;
            }
        }
        const modalRef = this.modalService.open(EditBuildingComponent, this.modalOptions);
        modalRef.componentInstance.modalTitle = "Edit outbuilding";
        modalRef.componentInstance.building = outTableSelection[0];
        modalRef.componentInstance.editedIndex = index;
        modalRef.result.then((updatedBuilding) => {
            this.changeDetectorRefs.markForCheck();
            if (updatedBuilding) {
                itemsAlreadyOnTable[updatedBuilding[0]] = updatedBuilding[1];
                const allItems = [...itemsAlreadyOnTable];
                outTableDataSource.next(allItems);
                outTableSelection[0].selected = false;
                this.getProperties.controls[propertyIndex].get("outTableSelection").setValue(outTableSelection);
                this.changeDetectorRefs.detectChanges();
                this.syncOutBuildings();
            }
        }).catch((res) => {
        });
    }
    onBtnAddOutClicked($event, propertyIndex) {
        let outTableSelection = this.getProperties.controls[propertyIndex].get("outTableSelection").value;
        const outTableDataSource = this.getProperties.controls[propertyIndex].get("outTableDataSource").value;
        const modalRef = this.modalService.open(AddBuildingComponent, this.modalOptions);
        modalRef.componentInstance.modalTitle = "Add outbuilding";
        modalRef.componentInstance.type = "Additional building";
        modalRef.result.then(newBuilding => {
            if (newBuilding) {
                const itemsAlreadyOnTable = outTableDataSource.getValue();
                const allItems = [...itemsAlreadyOnTable, newBuilding];
                for (let index = 0; index < allItems.length; index++) {
                    if (allItems[index].id > 0)
                        continue;
                    // allItems[index].id = index!==0 ? -index : 0;
                    // hack for test:
                    allItems[index].id = index !== 0 ? -index - 100 : -100;
                }
                outTableDataSource.next(allItems);
                outTableSelection = [];
                this.getProperties.controls[propertyIndex].get("outTableSelection").setValue(outTableSelection);
                this.changeDetectorRefs.detectChanges();
                this.syncOutBuildings();
            }
        }).catch((res) => {
        });
    }
    getMissingZones(index) {
        if (this.missingZoneList && this.missingZoneList.size > 0) {
            // send email to mod admins if it not been already sent
            this.missingZoneTuple = this.missingZoneList.get(index);
            if (this.missingZoneTuple[1] === false) {
                this.sendEmailMissingLookupForZones(this.missingZoneTuple[0]);
                this.missingZoneTuple = [this.missingZoneTuple[0], true];
                this.missingZoneList.set(index, this.missingZoneTuple);
            }
            let zones = "";
            let count = 1;
            this.missingZoneTuple[0].forEach((zone) => {
                zones += zone + (count < zone.length ? "|" : "");
                count++;
            });
            return `${CreateApplicationLocationBpamsConstants.MISSING_ZONE_LABEL} ${zones} ${CreateApplicationLocationBpamsConstants.MISSING_ZONE_LABEL_EMAIL}`;
        }
    }
    mainArrayReturned(array, index) {
        this.getProperties.controls[index].get("mainTableSelection").setValue(array);
    }
    outArrayReturned(array, index) {
        this.getProperties.controls[index].get("outTableSelection").setValue(array);
    }
    syncMainBuildings() {
        this.getProperties.controls.forEach(property => {
            const items = property.get("mainTableDataSource").value.getValue();
            const formItems = property.get("mainBuildings");
            formItems.clear();
            items.forEach(item => {
                const newItem = new FormGroup({
                    floor: new FormControl(item.floor),
                    existingSize: new FormControl(item.existingSize),
                    addedSize: new FormControl(item.addedSize)
                });
                formItems.push(newItem);
            });
        });
        this.calculateTotals();
    }
    syncOutBuildings() {
        this.getProperties.controls.forEach(property => {
            const items = property.get("outTableDataSource").value.getValue();
            const formItems = property.get("outBuildings");
            formItems.clear();
            items.forEach(item => {
                const newItem = new FormGroup({
                    floor: new FormControl(item.floor),
                    existingSize: new FormControl(item.existingSize),
                    addedSize: new FormControl(item.addedSize)
                });
                formItems.push(newItem);
            });
        });
        this.calculateTotals();
    }
    calculateTotals() {
        const properties = this.getProperties.controls;
        properties.forEach(property => {
            property.get("coverage").setValue(0);
            property.get("bulkCalculation").setValue(0);
            let totalExistingPatioCalculated = 0.00;
            let totalAddedPatioCalculated = 0.00;
            let totalExistingCalculated = 0.00;
            let totalAddedCalculated = 0.00;
            let totalFloorCalculated = 0.00;
            let totalGroundFloorCalculated = 0.00;
            try {
                if (property.get("coveredExisting").value && property.get("coveredAdded").value && property.get("openExisting").value && property.get("openAdded").value) {
                    const patioCoverageExisting = property.get("coveredExisting").value;
                    const patioCoverageAdded = property.get("coveredAdded").value;
                    const patioOpenExisting = property.get("openExisting").value;
                    const patioOpenAdded = property.get("openAdded").value;
                    totalExistingPatioCalculated += patioCoverageExisting + patioOpenExisting;
                    totalAddedPatioCalculated += patioCoverageAdded + patioOpenAdded;
                    property.get("totalExistingPatio").setValue(totalExistingPatioCalculated);
                    property.get("totalAddedPatio").setValue(totalAddedPatioCalculated);
                }
            }
            catch (e) {
                // Ignore this, the user might give invalid inputs which are handled by the validators
            }
            try {
                const mainBuildings = property.get("mainBuildings");
                const outBuildings = property.get("outBuildings");
                mainBuildings.controls.forEach(building => {
                    totalExistingCalculated += building.get("existingSize").value;
                    totalAddedCalculated += building.get("addedSize").value;
                    if (building.get("floor").value === 0) {
                        totalGroundFloorCalculated += building.get("existingSize").value;
                        totalGroundFloorCalculated += building.get("addedSize").value;
                    }
                });
                outBuildings.controls.forEach(building => {
                    totalExistingCalculated += building.get("existingSize").value;
                    totalAddedCalculated += building.get("addedSize").value;
                    if (building.get("floor").value === 0) {
                        totalGroundFloorCalculated += building.get("existingSize").value;
                        totalGroundFloorCalculated += building.get("addedSize").value;
                    }
                });
                totalFloorCalculated = totalAddedCalculated + totalExistingCalculated;
                property.get("totalExisting").setValue(totalExistingCalculated);
                property.get("totalAdded").setValue(totalAddedCalculated);
                property.get("totalFloorArea").setValue(totalFloorCalculated);
            }
            catch (e) {
                // Ignore this, the user might give invalid inputs which are handled by the validators
            }
            try {
                if (property.get("coveredExisting").value !== null && property.get("coveredAdded").value !== null && property.get("erfSize").value !== null) {
                    const patioCoverageExisting = property.get("coveredExisting").value;
                    const patioCoverageAdded = property.get("coveredAdded").value;
                    const totalCoveredPatio = 0.00 + patioCoverageExisting + patioCoverageAdded;
                    const totalCoveredArea = 0.00 + totalExistingCalculated + totalAddedCalculated + totalCoveredPatio;
                    const totalFloorArea = 0.00 + totalGroundFloorCalculated + totalCoveredPatio;
                    const totalArea = 0.00 + property.get("erfSize").value;
                    const covered = totalCoveredArea / totalArea * 100;
                    const bulkCalculation = totalFloorArea / totalArea * 100;
                    property.get("coverage").setValue(Math.round(covered * 100) / 100);
                    property.get("bulkCalculation").setValue(Math.round(bulkCalculation * 100) / 100);
                }
            }
            catch (e) {
                // Ignore this, the user might give invalid inputs which are handled by the validators
            }
        });
    }
    setNumberToDecimal(formControl, event) {
        //  sets number to two decimal places
        const value = event.target.value;
        const decimalValue = parseFloat(value).toFixed(2);
        formControl.setValue(decimalValue);
    }
    // this fix is for the "Totals" fields which are not being populated when the form reloads
    syncMainBuildingsOnGet(PropertyFormGroup, property) {
        const mainTableDataSource = PropertyFormGroup.get("mainTableDataSource").value;
        const mb = new Array();
        property.buildings.forEach(item => {
            if (item.type == "Main Building") {
                mb.push(item);
            }
        });
        mainTableDataSource.next(mb);
    }
    // this fix is for the "Totals" fields which are not being populated when the form reloads
    syncOutBuildingsOnGet(PropertyFormGroup, property) {
        const mainTableDataSource = PropertyFormGroup.get("outTableDataSource").value;
        const ad = new Array();
        property.buildings.forEach(item => {
            if (item.type == "Additional Building") {
                ad.push(item);
            }
        });
        mainTableDataSource.next(ad);
    }
    subscribeToClearMapGraphics() {
        this.applicationCreateService.$clearLayerGraphicsSubject.subscribe({
            next: (clearGraphics) => {
                if (clearGraphics) {
                    this.mapComponent.removeGraphicsFromMap("Building Plans graphics");
                    this.mapTools.sketchGraphicsLayer.removeAll();
                    this.changeDetectorRefs.detectChanges();
                }
            }
        });
    }
    subscribeToSelectedApplication() {
        this.cleanupAfterDestroy(this.selectedApplicationService.$selectedApplication).subscribe((application) => {
            this.selectedApplication = +this.jobId > 0 && application ? application : null;
            if (this.selectedApplication) {
                this.onGetSelectedApplication();
                CreateApplicationUtils.updatePropertyIds(this.selectedApplication, this.propertiesForm);
                this.changeDetectorRefs.detectChanges();
            }
        });
    }
    initForm() {
        this.propertiesForm = this.aflaModuleStrategyService.form.get("propertiesForm");
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.applicationCreateService.moduleID} and (name eq 'PropertyRoofing' or name eq 'ApplicationType' or name eq 'PropertyEstimatedBy' or name eq 'PropertyExternalWalls' or name eq 'PropertyInternalWalls' or name eq 'Zoning')`,
        };
        this.applicationCreateService.getLookupsObservable(params).subscribe({
            next: (response) => this.onGetLookupsCompleted(response), error: (error) => {
                this.appController.handleServerErrorMessage(CreateApplicationLocationBpamsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const types = [];
        const estimatedBys = [];
        const externalWalls = [];
        const internalWalls = [];
        const roofings = [];
        const zones = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "PropertyRoofing") {
                    roofings.push(JSON.parse(item.content));
                }
                if (item.name === "ApplicationType") {
                    types.push(JSON.parse(item.content));
                }
                if (item.name === "PropertyEstimatedBy") {
                    estimatedBys.push(JSON.parse(item.content));
                }
                if (item.name === "PropertyExternalWalls") {
                    externalWalls.push(JSON.parse(item.content));
                }
                if (item.name === "PropertyInternalWalls") {
                    internalWalls.push(JSON.parse(item.content));
                }
                if (item.name === "Zoning") {
                    zones.push(JSON.parse(item.content));
                }
            });
        }
        this.aflaModuleStrategyService.lookups.set("zoneOptions", zones);
        this.zoneOptions = zones;
        this.sortZones();
        this.aflaModuleStrategyService.lookups.set("typeOptions", types);
        this.typeOptions = types;
        this.aflaModuleStrategyService.lookups.set("estimatedByOptions", estimatedBys);
        this.estimatedByOptions = estimatedBys;
        this.aflaModuleStrategyService.lookups.set("externalWallsOptions", externalWalls);
        this.externalWallsOptions = externalWalls;
        this.aflaModuleStrategyService.lookups.set("internalWallsOptions", internalWalls);
        this.internalWallsOptions = internalWalls;
        this.aflaModuleStrategyService.lookups.set("roofingOptions", roofings);
        this.roofingOptions = roofings;
        this.applicationCreateService.setHasLoadedLookups(true);
        this.subscribeToSelectedApplication();
        this.changeDetectorRefs.detectChanges();
    }
    propertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    loadExistingProperty(property) {
        this.setPropertyData(property, property.geometry);
    }
    setPropertyData(propertyObject, geometry) {
        this.requestStatusService.showBusySpinner("GetPropertyData");
        const sgCode = this.propertyDataAlternateColumnName(propertyObject, "SgCode", "sgCode");
        let found = false;
        this.changeDetectorRefs.detectChanges();
        const propertiesFormArray = this.propertiesForm.get("properties");
        propertiesFormArray.updateValueAndValidity();
        propertiesFormArray.controls?.sort((a, b) => {
            return a?.get("tempId").value > b?.get("tempId").value ? 1 : -1;
        })?.forEach(control => {
            const check = control.get("sgCode").value;
            if (check === sgCode) {
                found = true;
                this.appController.showMessage(CreateApplicationLocationBpamsConstants.DUPLICATE_MESSAGE, AlertType.Warning);
                this.requestStatusService.removeBusySpinner("GetPropertyData");
            }
        });
        // TODO: build a lookup map for mapping the propertyData layer to the data for Property
        if (!found) {
            const newProperty = new FormGroup({
                id: new FormControl(0),
                tempId: new FormControl(this.getProperties.length, Validators.required),
                type: new FormControl(null, [Validators.required]),
                erfNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "ErfNo", "erfNumber")),
                subdivision: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Subdivision", "ptnNum")),
                allotment: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Allotment", "allotment")),
                farmNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "FarmNo", "farmNumber")),
                sgCode: new FormControl(sgCode, [Validators.required]),
                shortDescription: new FormControl(null, [Validators.required]),
                titleDeedRestrictions: new FormControl(null, [Validators.required]),
                address: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Address", "address"), [Validators.required]),
                erfSize: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "ErfSize", "erfSize"), [Validators.required]),
                totalValue: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "TotalValue", "totalValue"), [Validators.required]),
                titleDeed: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "TitleDeed"), [Validators.required]),
                estimatedBy: new FormControl(null, [Validators.required]),
                estimatedCost: new FormControl(null, [Validators.required]),
                zones: new FormArray([], [Validators.min(1)]),
                // building details
                externalWalls: new FormControl(null, [Validators.required]),
                internalWalls: new FormControl(null, [Validators.required]),
                roofing: new FormControl(null, [Validators.required]),
                numberOfHousesUnits: new FormControl(null, [Validators.required]),
                // main building
                mainBuildings: new FormArray([]),
                mainTableDataSource: new FormControl(new BehaviorSubject([])),
                mainTableSelection: new FormControl([]),
                outBuildings: new FormArray([]),
                outTableDataSource: new FormControl(new BehaviorSubject([])),
                outTableSelection: new FormControl([]),
                totalExisting: new FormControl({ value: 0, disabled: true }),
                totalAdded: new FormControl({ value: 0, disabled: true }),
                totalFloorArea: new FormControl({ value: 0, disabled: true }),
                // Patio/stoeps
                coveredExisting: new FormControl(0, [Validators.required]),
                coveredAdded: new FormControl(0, [Validators.required]),
                openExisting: new FormControl(0, [Validators.required]),
                openAdded: new FormControl(0, [Validators.required]),
                totalExistingPatio: new FormControl({ value: 0, disabled: true }),
                totalAddedPatio: new FormControl({ value: 0, disabled: true }),
                // Misc.
                pool: new FormControl(0, [Validators.required]),
                boundaryWallHeight: new FormControl(0, [Validators.required]),
                boundaryWallRunning: new FormControl(0, [Validators.required]),
                coverage: new FormControl({ value: 0, disabled: true }),
                bulkCalculation: new FormControl({ value: 0, disabled: true }),
                owners: new FormControl(null, [Validators.required]),
                geometry: new FormControl(geometry),
                centroid: new FormControl(null, [Validators.required])
            });
            const proxyUrl = ApiProxyConstants.URL;
            const gpToolUrl = AppConfig.settings.arcGIS.servicesURL + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
            const url = `${proxyUrl}?${gpToolUrl}`;
            const formData = new FormData();
            formData.append("f", "json");
            formData.append("geometryJSON", JSON.stringify(geometry));
            this.applicationCreateService.getTrueCentroid(url, formData)
                .subscribe({
                next: (trueCentroidResponse) => {
                    newProperty.get("centroid").setValue(trueCentroidResponse.results[0].value);
                    const zoningLayerObj = this.mapService.userMaps.find(a => a.selectionLayerType === MapServiceConstants.PROPERTY_ZONING_LAYER);
                    if (zoningLayerObj !== undefined && zoningLayerObj !== null) {
                        const zoningLayer = zoningLayerObj.layer;
                        const zoningQuery = new Query();
                        zoningQuery.where = `SgCode = '${sgCode}'`;
                        zoningQuery.returnGeometry = false;
                        zoningQuery.outFields = ["*"];
                        zoningLayer.queryFeatures(zoningQuery).then((zoneFeatureSet) => {
                            // Make sure the grave centroid is within one cemetery boundary
                            const zonesControl = newProperty.get("zones");
                            if (zoneFeatureSet.features.length > 0) {
                                zoneFeatureSet.features.forEach(item => {
                                    const zone = CreateApplicationUtils.propertyDataAlternateColumnName(item.attributes, "Zoning", "zoning");
                                    if (zone !== undefined && zone != null) {
                                        let foundZone = null;
                                        this.zoneOptions.forEach(zoneItem => {
                                            if (zoneItem.value === zone) {
                                                foundZone = zoneItem;
                                            }
                                        });
                                        if (foundZone !== null) {
                                            zonesControl.push(new FormGroup({
                                                zone: new FormControl(foundZone, [Validators.required])
                                            }));
                                        }
                                        else {
                                            this.appController.showMessage(CreateApplicationLocationBpamsConstants.ZONING_NOT_FOUND.replace("{0}", zone), AlertType.Warning);
                                        }
                                    }
                                    else {
                                        this.appController.showMessage(CreateApplicationLocationBpamsConstants.INVALID_ZONING_ATTRIBUTE, AlertType.Error);
                                    }
                                });
                            }
                            if (zonesControl.length === 0) {
                                zonesControl.push(new FormGroup({
                                    zone: new FormControl(null, [Validators.required])
                                }));
                            }
                            const propertyControl = this.getProperties;
                            propertyControl.push(newProperty);
                            this.active = propertyControl.length - 1;
                            this.changeDetectorRefs.detectChanges();
                            this.syncMapGeometries();
                            this.requestStatusService.removeBusySpinner("GetPropertyDate");
                        }, (zoningError) => {
                            this.appController.showMessage(zoningError.message, AlertType.Error);
                            const propertyControl = this.getProperties;
                            propertyControl.push(newProperty);
                            this.active = propertyControl.length - 1;
                            this.changeDetectorRefs.detectChanges();
                            this.syncMapGeometries();
                            this.requestStatusService.removeBusySpinner("GetPropertyDate");
                        });
                        this.updatePropertyRequiredFields(newProperty);
                        this.sortZones();
                    }
                    else {
                        this.updatePropertyRequiredFields(newProperty);
                        const propertyControl = this.getProperties;
                        propertyControl.push(newProperty);
                        this.active = propertyControl.length - 1;
                        this.changeDetectorRefs.detectChanges();
                        this.syncMapGeometries();
                        this.requestStatusService.removeBusySpinner("GetPropertyDate");
                    }
                }, error: (error) => {
                    this.requestStatusService.removeBusySpinner("GetPropertyDate");
                    this.appController.handleServerErrorMessage(CreateApplicationLocationBpamsConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                }
            });
        }
    }
    onGetSelectedApplication() {
        if (+this.jobId > 0 && this.selectedApplication) {
            this.missingZoneList = new Map();
            this.applicationCreateService.$missingLookupsForZones = [];
            const propertyControl = this.getProperties;
            propertyControl.clear();
            let index = 0;
            const missingLookupsForZones = [];
            this.selectedApplication.properties.sort((a, b) => (a?.id - b?.id));
            this.selectedApplication.properties.forEach(property => {
                const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(property.shape, 102100);
                const geom = JsonUtils.fromJSON(geometryArc);
                const newProperty = new FormGroup({
                    id: new FormControl(property.id),
                    property: new FormControl(property),
                    erfNo: new FormControl(property.erfNumber),
                    subdivision: new FormControl(property.subdivision),
                    allotment: new FormControl(property.allotment, [Validators.required]),
                    farmNo: new FormControl(property.farmNumber),
                    sgCode: new FormControl(property.sgCode, [Validators.required]),
                    address: new FormControl(property.address, [Validators.required]),
                    erfSize: new FormControl(property.erfSize, [Validators.required]),
                    totalValue: new FormControl(property.totalValue, [Validators.required]),
                    titleDeed: new FormControl(property.titleDeed, [Validators.required]),
                    geometry: new FormControl(geom), centroid: new FormControl(null, [Validators.required]),
                    zones: new FormArray([], [Validators.min(1), Validators.required]),
                    owners: new FormControl(property.owners, [Validators.required]),
                    shortDescription: new FormControl(property.applicationDescription, [Validators.required]),
                    titleDeedRestrictions: new FormControl(property.applicationRestrictions, [Validators.required]),
                    type: new FormControl(null, [Validators.required]),
                    estimatedBy: new FormControl(null, [Validators.required]),
                    estimatedCost: new FormControl(property.applicationEstimatedCost, [Validators.required]),
                    externalWalls: new FormControl(null, [Validators.required]),
                    internalWalls: new FormControl(null, [Validators.required]),
                    roofing: new FormControl(null, [Validators.required]),
                    numberOfHousesUnits: new FormControl(property.numberOfHouses, [Validators.required]),
                    totalExisting: new FormControl({ value: 0, disabled: true }),
                    totalAdded: new FormControl({ value: 0, disabled: true }),
                    totalFloorArea: new FormControl({ value: 0, disabled: true }),
                    // patio
                    coveredExisting: new FormControl(property.patioCoveredExisting, [Validators.required]),
                    coveredAdded: new FormControl(property.patioCoveredAdded, [Validators.required]),
                    openExisting: new FormControl(property.patioOpenExisting, [Validators.required]),
                    openAdded: new FormControl(property.patioOpenAdded, [Validators.required]),
                    totalExistingPatio: new FormControl({ value: 0, disabled: true }),
                    totalAddedPatio: new FormControl({ value: 0, disabled: true }),
                    // misc
                    pool: new FormControl(property.pool, [Validators.required]),
                    boundaryWallHeight: new FormControl(property.boundaryWallHeight, [Validators.required]),
                    boundaryWallRunning: new FormControl(property.boundaryWallRunning, [Validators.required]),
                    coverage: new FormControl({ value: property.coverage, disabled: true }),
                    bulkCalculation: new FormControl({ value: property.bulkCalculation, disabled: true }),
                    mainBuildings: new FormArray([]), outBuildings: new FormArray([]),
                    mainTableDataSource: new FormControl(new BehaviorSubject([])),
                    mainTableSelection: new FormControl([]),
                    outTableDataSource: new FormControl(new BehaviorSubject([])),
                    outTableSelection: new FormControl([])
                });
                // if property is loaded from an existing application mark for as touched it as touched
                this.propertiesForm.markAllAsTouched();
                this.updatePropertyRequiredFields(newProperty);
                const zonesControl = newProperty.get("zones");
                property.zonings.forEach(zone => {
                    let foundZone = false;
                    this.zoneOptions.forEach(zoneOption => {
                        if (zoneOption.value === zone.zoning) {
                            foundZone = true;
                            const zoneGroup = new FormGroup({
                                id: new FormControl(zone.id), applicationPropertyId: new FormControl(zone.applicationPropertyId), zone: new FormControl(zoneOption, [Validators.required]), deleted: new FormControl(zone.deleted)
                            });
                            zonesControl.push(zoneGroup);
                        }
                    });
                    if (!foundZone) {
                        missingLookupsForZones.push(zone.zoning);
                        this.applicationCreateService.$missingLookupsForZones.push(zone.zoning);
                    }
                });
                if (missingLookupsForZones.length > 0) {
                    this.missingZoneTuple = [missingLookupsForZones, false];
                    this.missingZoneList.set(index, this.missingZoneTuple);
                }
                const mainTableDataSource = newProperty.get("mainTableDataSource").value;
                const outTableDataSource = newProperty.get("outTableDataSource").value;
                const mainItems = [];
                const outItems = [];
                mainTableDataSource.next(mainItems);
                outTableDataSource.next(outItems);
                let applicationType = null;
                this.typeOptions.forEach(item => {
                    if (item.value === property.applicationType) {
                        applicationType = item;
                    }
                });
                let applicationEstimatedBy = null;
                this.estimatedByOptions.forEach(item => {
                    if (item.value === property.applicationEstimatedBy) {
                        applicationEstimatedBy = item;
                    }
                });
                let externalWalls = null;
                this.externalWallsOptions.forEach(item => {
                    if (item.value === property.externalWalls) {
                        externalWalls = item;
                    }
                });
                let internalWalls = null;
                this.internalWallsOptions.forEach(item => {
                    if (item.value === property.internalWalls) {
                        internalWalls = item;
                    }
                });
                let roofing = null;
                this.roofingOptions.forEach(item => {
                    if (item.value === property.roofing) {
                        roofing = item;
                    }
                });
                newProperty.get("type").setValue(applicationType);
                newProperty.get("estimatedBy").setValue(applicationEstimatedBy);
                newProperty.get("externalWalls").setValue(externalWalls);
                newProperty.get("internalWalls").setValue(internalWalls);
                newProperty.get("roofing").setValue(roofing);
                // todo Temporary fix:
                this.syncMainBuildingsOnGet(newProperty, property);
                this.syncOutBuildingsOnGet(newProperty, property);
                this.calculateTotalsOnGet(newProperty);
                const proxyUrl = ApiProxyConstants.URL;
                const gpToolUrl = AppConfig.settings.arcGIS.servicesURL + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
                const url = `${proxyUrl}?${gpToolUrl}`;
                const formData = new FormData();
                formData.append("f", "json");
                formData.append("geometryJSON", JSON.stringify(geometryArc));
                this.applicationCreateService.getTrueCentroid(url, formData).subscribe({
                    next: (response) => {
                        newProperty.get("centroid").setValue(response.results[0].value);
                        propertyControl.push(newProperty);
                        this.active = propertyControl.length - 1;
                        this.syncMapGeometries();
                        CreateApplicationUtils.updatePropertyIds(this.selectedApplication, this.propertiesForm);
                        this.changeDetectorRefs.detectChanges();
                    }, error: (error) => {
                        this.appController.handleServerErrorMessage(ViewApplicationLocationBpamsConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                    }
                });
                index++;
            });
            if (this.isMapLoaded) {
                this.syncMapGeometries();
            }
            this.hasLoadedApplicationProperties = true;
            this.changeDetectorRefs.detectChanges();
        }
    }
    syncMapGeometries() {
        const geometries = [];
        this.getProperties.controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Building plans graphics", true);
        }
        else {
            this.mapComponent.removeGraphicsFromMap("Building plans graphics");
        }
    }
    subscribeToProperty() {
        this.cleanupAfterDestroy(this.mapService.$selectedProperty).subscribe(property => {
            if (property !== null) {
                this.setPropertyData(property.attributes, property.geometry);
            }
        });
    }
    sendEmailMissingLookupForZones(missingLookupsForZones) {
        const url = `${ApiModuleConstants.URL}/${ApiModuleConstants.MISSING_LOOKUP_EMAIL_REQUEST_URL}`;
        const params = {
            moduleId: this.applicationCreateService.moduleID, lookupType: "Zoning", lookupList: missingLookupsForZones
        };
        this.cleanupAfterDestroy(this.applicationCreateService.sendMissingLookupsEmail(url, params))
            .subscribe({
            next: () => {
            }, error: (error) => {
                this.appController.handleServerErrorMessage(`${CreateApplicationLocationBpamsConstants.MISSING_ZONE_LABEL_EMAIL_FAILED}`, error, CRUDOperation.Selecting);
            }
        });
    }
    initializeColumnToObjectMapping() {
        this.mainTableMapper = PropertyBuildingHeadingEnumHeadingLookup;
        this.outTableMapper = PropertyBuildingHeadingEnumHeadingLookup;
    }
    // NOTE: This is a Temporary fix - To be changed
    subscribeToClearGraphics() {
        this.applicationCreateService.$clearLayerGraphicsSubject.subscribe({
            next: (clearGraphics) => {
                if (clearGraphics) {
                    this.getProperties.clear();
                    this.mapComponent.removeGraphicsFromMap("Building plans graphics");
                    this.changeDetectorRefs.detectChanges();
                }
            }
        });
    }
    // NOTE: This is a Temporary fix - To be changed
    sortZones() {
        // sort zones dropdown alphabetically
        this.zones?.sort((a, b) => (a.value?.localeCompare(b?.value)));
        this.zoneOptions?.sort((a, b) => (a.value?.localeCompare(b?.value)));
    }
    // NOTE: This is a Temporary fix - To be changed
    // this fix is for the "Totals" fields which are not being populated when the form reloads after a save
    calculateTotalsOnGet(PropertyFormGroup) {
        PropertyFormGroup.get("coverage").setValue(0);
        PropertyFormGroup.get("bulkCalculation").setValue(0);
        let totalExistingPatioCalculated = 0.00;
        let totalAddedPatioCalculated = 0.00;
        let totalExistingCalculated = 0.00;
        let totalAddedCalculated = 0.00;
        let totalFloorCalculated = 0.00;
        let totalGroundFloorCalculated = 0.00;
        try {
            if (PropertyFormGroup.get("coveredExisting").value !== null &&
                PropertyFormGroup.get("coveredAdded").value !== null &&
                PropertyFormGroup.get("openExisting").value !== null &&
                PropertyFormGroup.get("openAdded").value !== null) {
                const patioCoverageExisting = PropertyFormGroup.get("coveredExisting").value;
                const patioCoverageAdded = PropertyFormGroup.get("coveredAdded").value;
                const patioOpenExisting = PropertyFormGroup.get("openExisting").value;
                const patioOpenAdded = PropertyFormGroup.get("openAdded").value;
                totalExistingPatioCalculated += patioCoverageExisting + patioOpenExisting;
                totalAddedPatioCalculated += patioCoverageAdded + patioOpenAdded;
                PropertyFormGroup.get("totalExistingPatio").setValue(totalExistingPatioCalculated);
                PropertyFormGroup.get("totalAddedPatio").setValue(totalAddedPatioCalculated);
            }
        }
        catch (e) {
            // Ignore this, the user might give invalid inputs which are handled by the validators
        }
        try {
            // const mainBuildings = PropertyFormGroup.get("mainBuildings") as FormArray;
            // const outBuildings = PropertyFormGroup.get("outBuildings") as FormArray;
            const mainTableDataSource = PropertyFormGroup.get("mainTableDataSource").value;
            const mainBuildings = mainTableDataSource.value;
            const outTableDataSource = PropertyFormGroup.get("outTableDataSource").value;
            const outBuildings = outTableDataSource.value;
            mainBuildings.forEach(building => {
                console.log(building);
                totalExistingCalculated += building.existingSize;
                totalAddedCalculated += building.addedSize;
                if (+building.floor === 0) {
                    totalGroundFloorCalculated += building.existingSize;
                    totalGroundFloorCalculated += building.addedSize;
                }
            });
            outBuildings.forEach(building => {
                totalExistingCalculated += building.existingSize;
                totalAddedCalculated += building.addedSize;
                if (+building.floor === 0) {
                    totalGroundFloorCalculated += building.existingSize;
                    totalGroundFloorCalculated += building.addedSize;
                }
            });
            totalFloorCalculated = totalAddedCalculated + totalExistingCalculated;
            PropertyFormGroup.get("totalExisting").setValue(totalExistingCalculated);
            PropertyFormGroup.get("totalAdded").setValue(totalAddedCalculated);
            PropertyFormGroup.get("totalFloorArea").setValue(totalFloorCalculated);
        }
        catch (e) {
            // Ignore this, the user might give invalid inputs which are handled by the validators
        }
        try {
            if (PropertyFormGroup.get("coveredExisting").value !== null &&
                PropertyFormGroup.get("coveredAdded").value !== null &&
                PropertyFormGroup.get("erfSize").value !== null) {
                const patioCoverageExisting = PropertyFormGroup.get("coveredExisting").value;
                const patioCoverageAdded = PropertyFormGroup.get("coveredAdded").value;
                const totalCoveredPatio = 0.00 + patioCoverageExisting + patioCoverageAdded;
                const totalCoveredArea = 0.00 + totalExistingCalculated + totalAddedCalculated + totalCoveredPatio;
                const totalFloorArea = 0.00 + totalGroundFloorCalculated + totalCoveredPatio;
                const totalArea = 0.00 + PropertyFormGroup.get("erfSize").value;
                const covered = totalCoveredArea / totalArea * 100;
                const bulkCalculation = totalFloorArea / totalArea * 100;
                PropertyFormGroup.get("coverage").setValue(Math.round(covered * 100) / 100);
                PropertyFormGroup.get("bulkCalculation").setValue(Math.round(bulkCalculation * 100) / 100);
            }
        }
        catch (e) {
            // Ignore this, the user might give invalid inputs which are handled by the validators
        }
    }
    checkAndInitialiseLookups() {
        this.hasLoadedApplicationProperties = false;
        this.applicationCreateService.setHasLoadedLookups(false);
        if (this.aflaModuleStrategyService.lookups.has("typeOptions")) {
            this.estimatedByOptions = this.aflaModuleStrategyService.lookups.get("estimatedByOptions");
            this.externalWallsOptions = this.aflaModuleStrategyService.lookups.get("externalWallsOptions");
            this.internalWallsOptions = this.aflaModuleStrategyService.lookups.get("internalWallsOptions");
            this.roofingOptions = this.aflaModuleStrategyService.lookups.get("roofingOptions");
            this.typeOptions = this.aflaModuleStrategyService.lookups.get("typeOptions");
            this.zoneOptions = this.aflaModuleStrategyService.lookups.get("zoneOptions");
            this.sortZones();
            this.applicationCreateService.setHasLoadedLookups(true);
            this.subscribeToSelectedApplication();
        }
        else {
            this.getLookups();
        }
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: MapService },
        { type: RequestStatusService },
        { type: MapTools },
        { type: ChangeDetectorRef },
        { type: NgbModal }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
CreateApplicationLocationBpamsComponent = __decorate([
    Component({
        selector: "app-create-application-location-bpams", template: __NG_CLI_RESOURCE__0, changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationLocationBpamsComponent);
